import React, {createContext} from "react";
import {IModalContext} from "./models/IModalContext.ts";

export const ModalContext = createContext<IModalContext>({
    isOpen: false,
    isBackButtonVisible: false,
    closeModal(): void {
    },
    showModal(header: React.ReactNode, content: React.ReactNode, maxHeightDesktop?: string): void {
        header;
        content;
        maxHeightDesktop;
    },
    setIsBackButtonVisible(isVisible: boolean): void {
        isVisible;
    },
    setBackButtonAction(action: (() => void) | undefined): void {
        action;
    }
});